<template>
    <div class="route-configuration">
      <div>
        <template v-if="route.hasOwnProperty('name')">
          <FormInput :label="l.t('app.name', 'Name')" class="my-5">
            <w-text-field v-model="route.name" hide-details='auto' data-test-id="route-conf-name-input" />
          </FormInput>
        </template>
        <draggable
          v-model="route.rules"
          handle=".dragging-element"
          ghost-class="dropzone"
          :forceFallback="true"
          @start="blur_all_selectors"
          @update="$global_emitter.$emit('form_input_changed')"
        >
        <div class="route-rule mb-10" v-for="(rule, i) in route['rules']" :key="rule.index" :data-test-id="`route-conf-rule-main-${i}`">
          <div class="route-rule-configuration">
                  <RouteRuleFilter
                    :_filter="rule['filter']"
                    :_extension="_extension ? _extension : route.extension"
                    :route="route"
                    :rule_index="i"
                    @updated="on_filter_update(i, $event)"
                    @closed="remove_rule(i)"
                    :data-test-id="`route-conf-rule-filter-${i}`"
                  >
                  </RouteRuleFilter>
              </div>
              <div class="mt-8">
                <div class="w-subtitle-2 info--text text--darken-1">
                  2. {{ l.t('routes.select-handled', 'Select how calls should be handled') }}
                </div>
                <RouteRuleActions
                  :rule="rule"
                  :rule_index="i"
                  :extension="extension"
                  :route="route"
                  @dragging="blur_all_selectors"
                />
              </div>
              <div
                v-if="rule['actions'].filter((v) => !['forward', 'hold', 'greeting', 'queue', 'live_answer'].includes(v['action'])).length === 0"
                class="routes-add-new-action"
              >
                <w-btn
                  text
                  changes-form
                  color="primary"
                  @click="rule['actions'].push({ action: 'disconnect'})"
                  class="pl-0 mx-auto"
                  block
                  :ripple="false"
                  :data-test-id="`route-conf-rule-${i}-add-action-btn`"
                >
                  <v-icon color="primary">mdi-plus-circle</v-icon> {{ l.t("call-flow.add-action", "Add next action") }}
              </w-btn>
              </div>
          </div>
        </draggable>
        <div class="route-add-new-rule">
          <w-btn
              text
              changes-form
              color="primary"
              class="pl-0 mx-auto"
              block
              :ripple="false"
              @click="add_new_rule"
              data-test-id="route-conf-add-rule-btn"
            >
              <v-icon color="primary">mdi-plus-circle</v-icon>{{ l.t("call-flow.add-new-rule", "Add new rule") }}
          </w-btn>
        </div>
      </div>
    </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import l from '../../../libs/lang';
  import Helpers from '../../../libs/helpers';
  import FormInput from '../form/FormInput.vue';
  import RouteRuleFilter from './RouteRuleFilter.vue';
  import AddToListButton from '../AddToListButton.vue';
  import RouteRuleActions from './RouteRuleActions.vue';
  import RemoveFromListButton from '../RemoveFromListButton.vue';

  export default {
    props: ['id', '_route', '_extension'],
    components: {
      draggable,
      FormInput,
      RouteRuleFilter,
      AddToListButton,
      RouteRuleActions,
      RemoveFromListButton,
    },
    data() {
      return {
        l,
        loading: true,
        loading_message: null,
        alert: null,
        route: this.$props._route ? this.$props._route : null,
        extension: null,
      };
    },
    watch: {
      route(value) {
        this.$emit('changed', value);
      },
      is_preset(value) {
        this.$emit('usesPreset', value);
      },
    },
    async created() {
      if (!this.$data.route) {
        if (this.$props.id) {
          this.$data.route = await this.$session.get_item(`/routes/${this.$props.id}`);
        } else {
          this.$data.route = { rules: [{ actions: [] }] };
        }
      }
      for (const index in this.$data.route.rules) {
        if (this.$data.route.rules[index]) {
          this.$data.route.rules[index].index = index;
        }
      }
      if (this.$props._extension || this.$data.route.extension) {
        this.$data.extension = this.$props._extension
          ? this.$props._extension
          : this.$data.route.extension;
      }
      this.$data.loading = false;
    },
    methods: {
      remove_rule(i) {
        this.$data.route.rules.splice(i, 1);
        if (!this.$data.route.rules.length) {
          setTimeout(() => {
            this.add_new_rule();
          }, 100);
        }
      },
      on_filter_update(index, data) {
        this.$data.route.rules[index].filter = data;
        this.add_empty_rule_if_needed();
      },
      add_empty_rule_if_needed() {
        const all_calls = this.$data.route.rules.find((x) => !x.filter);
        if (!all_calls) {
          this.add_new_rule();
        }
      },
      add_new_rule() {
        if (!this.$data.route.rules) {
          this.$data.route.rules = [];
        }
        const empty_rule = Helpers.empty_route_rule();
        if (this.$data.route.rules.length) {
          empty_rule.index = Date.now();
          this.$data.route.rules.push(empty_rule);
        } else {
          empty_rule.index = 1;
          this.$data.route.rules = [empty_rule];
        }
        this.$forceUpdate();
        return true;
      },
      blur_all_selectors() {
        // when dragging items, selectors would stay closed.
        // This isn't perfect, but didn't want to kill a fly with a cannonball
        const header = document.getElementById('large-header');
        if (header) header.click();
      }
    },
  };
</script>
